<h2>{{name}}</h2>
<hr/>
<h5>{{desc}}</h5>
<p>Generates an input to display a date (day + month + year), and the attached day picker modal to select it from a calendar</p>
<p>
  This is a wrapper for the <a href="https://ng-bootstrap.github.io/#/components/datepicker/overview">Angular Bootstrap Datepicker</a>.
  It adds the input where to display the current value of a date, and the controls to open the calendar and pick a different value.
  <br>
  The model uses no "Date" data types, but strings with the default format 'yyyy-mm-dd', which is the standard format that
  is used for the Blueface API to get and set date fields.
</p>
<p>
  By default the 'shortDate' format is applied to display the date on the input (see <a href="https://angular.io/api/common/DatePipe#pre-defined-format-options">Angular Date Pipe</a> for more formats).
  If an i18n format is applied, the locale configuration can be provided to change is as needed.
  <br>
  It is important that the locales used are defined in the application that consumes the library via <b>registerLocaleData(localeZhCN, 'zh-CN');</b>
</p>

<h5 class="mt-4">Parameters:</h5>
<div class="col-12"><pre>{{api}}</pre></div>


<!--jb-date-picker Customization-->
<div class="whiteBg">
  <div class="row">

    <!--<div class="col-12">-->
    <!--  <div class="input-group" style="width: 250px;">-->
    <!--    <input class="form-control" placeholder="yyyy-mm-dd" name="dp"-->
    <!--           [(ngModel)]="model" (ngModelChange)="checkNewModel(model)"-->
    <!--           ngbDatepicker #d="ngbDatepicker">-->
    <!--    <div class="input-group-append">-->
    <!--      <button class="btn btn-outline-secondary calendar" (click)="d.toggle()" type="button"></button>-->
    <!--    </div>-->
    <!--  </div>-->
    <!--</div>-->


    <!--<div class="col-5 text-right">-->
    <!--  <jb-date-picker [(ngModel)]="myDate"-->
    <!--                  jbLabel="view.common.field_name3"-->
    <!--                  [jbLocale]="jbTranslate.currentLocale">-->
    <!--  </jb-date-picker>-->
    <!--</div>-->

    <div class="col-5 marB15">
      <h5 class="marB25">Customization:</h5>
      <div *ngIf="isCompLinked">
        <form #datePickerForm="ngForm">
          <jb-date-picker [class.flat]="compConf.hasFlat" [class.modal-right]="compConf.hasModalRight"
                          [class.no-min-width]="compConf.hasNoMinWidth"
            [(ngModel)]="myDate" (ngModelChange)="checkNewModel($event)"
            [jbRequired]="!!compConf.isRequired"
            [jbDisabled]="!!compConf.isDisabled"
            [jbHasClearBtn]="!!compConf.hasClearBtn"
            [jbLabel]="compConf.hasLabel ? compConf.labelText : ''"

            [jbTooltip]="(compConf.hasTooltip ? compConf.tooltipText : null)"
            [jbTooltipPos]="(compConf.tooltipPos || 'top')"
            [jbTooltipBody]="compConf.tooltipBody"
            [jbErrorText]="compConf.tooltipText ? compConf.tooltipText : ''"
            [jbErrorPos]="compConf.errorPos"

            [jbLocale]="compConf.jbLocale"
            [jbFormat]="compConf.jbFormat"
            [jbMinDate]="compConf.jbMinDate"
            [jbMaxDate]="compConf.jbMaxDate"
            name="demo_datepicker"
            #demoDatePicker="ngModel"
          ></jb-date-picker>
          Form Invalid = {{datePickerForm.invalid}}, pristine = {{datePickerForm.pristine}}
          <span *ngIf="datePickerForm.invalid"> | Errors = {{demoDatePicker.errors | json }}</span>
        </form>
      </div>

      <div class="row">
        <div class="col-12"><hr></div>
        <jb-input class="col-6" [(ngModel)]="myDate" (ngModelChange)="myDate2 = myDate"
                  jbLabel="myDate (model value)">
        </jb-input>
        <jb-input class="col-6" [(ngModel)]="myDate2" jbLabel="New value to set"
                  jbRightBtnText="Set to myDate" (jbRightBtnClick)="myDate = myDate2">
        </jb-input>
      </div>

      <div>
        <div class="code-box pad15">
          <pre>{{customCompCode}}</pre>
        </div>
      </div>
    </div>

    <div class="col-7">

      <!--Required, Disabled, Clean btn-->
      <div class="row marT15">
        <div class="col-3 padT5"> <jb-checkbox [(ngModel)]="compConf.isRequired" (ngModelChange)="upComp()" jbLabel="Is Required"></jb-checkbox> </div>
        <div class="col-3 padT5"> <jb-checkbox [(ngModel)]="compConf.isDisabled" (ngModelChange)="upComp()" jbLabel="Is Disabled"></jb-checkbox> </div>
        <div class="col-3 padT5"> <jb-checkbox [(ngModel)]="compConf.hasClearBtn" (ngModelChange)="upComp()" jbLabel="Has Clear Button"></jb-checkbox> </div>
      </div>

      <!--Label-->
      <div class="row marT15">
        <div class="col-3 padT5"> <jb-checkbox [(ngModel)]="compConf.hasLabel" (ngModelChange)="upComp()" jbLabel="Has Label"></jb-checkbox> </div>
        <div class="col-9" style="margin-bottom: -5px;"> <jb-input [(ngModel)]="compConf.labelText" (ngModelChange)="upComp()" [jbDisabled]="!compConf.hasLabel"></jb-input> </div>
      </div>

      <!--Tooltip-->
      <div class="row marT5" *ngIf="compConf.hasLabel">
        <div class="col-3 padT5"> <jb-checkbox [(ngModel)]="compConf.hasTooltip" (ngModelChange)="upComp()" jbLabel="Has Tooltip"></jb-checkbox> </div>
        <div class="col-9" *ngIf="compConf.hasTooltip">
          <jb-input [(ngModel)]="compConf.tooltipText" (ngModelChange)="upComp()"></jb-input>
        </div>
        <div class="col-3" *ngIf="compConf.hasTooltip"></div>
        <div class="col-5" *ngIf="compConf.hasTooltip">
          <jb-dropdown jbLabel="jbTooltipPos" [(ngModel)]="compConf.tooltipPos" (ngModelChange)="upComp()" [jbList]="tooltipPosList" jbRender="text" jbSelect="id"> </jb-dropdown>
        </div>
        <div class="col-4" *ngIf="compConf.hasTooltip">
          <jb-dropdown jbLabel="jbTooltipBody" [(ngModel)]="compConf.tooltipBody" (ngModelChange)="upComp()" [jbList]="tooltipBodyList" jbRender="text" jbSelect="id"> </jb-dropdown>
        </div>
      </div>

      <!-- Custom Format + Locale-->
      <div class="row marT15">
        <div class="col-3 padT30"> <jb-checkbox [(ngModel)]="compConf.hasCustomFormat" (ngModelChange)="upComp()" jbLabel="Custom Format"></jb-checkbox> </div>
        <div class="col-5">
          <jb-dropdown class="full-width" [jbDisabled]="!compConf.hasCustomFormat"
                       [(ngModel)]="compConf.jbFormat" (ngModelChange)="upComp()"
                       [jbList]="formatsList"
                       jbLabel="Format"
                       jbSelect="code"
                       jbRender="name">
          </jb-dropdown>
        </div>
        <div class="col-4">
          <jb-dropdown class="full-width"
                       [(ngModel)]="compConf.jbLocale"
                       [jbList]="localesList" (ngModelChange)="upComp()"
                       jbLabel="jbLocale"
                       jbSelect="code"
                       jbRender="name">
          </jb-dropdown>
        </div>
      </div>

      <!--Min / Max-->
      <div class="row marT15">
        <div class="col-4">
          <jb-date-picker jbLabel="jbMinDate"
                  [(ngModel)]="compConf.jbMinDate" (ngModelChange)="upComp()"
                  [jbHasClearBtn]="true"
                  [jbFormat]="compConf.jbFormat"
          ></jb-date-picker>
        </div>
        <div class="col-4">
          <jb-date-picker jbLabel="jbMaxDate"
                  [(ngModel)]="compConf.jbMaxDate" (ngModelChange)="upComp()"
                  [jbHasClearBtn]="true"
                  [jbFormat]="compConf.jbFormat"
          ></jb-date-picker>
        </div>
        <div class="col-4">
          <jb-dropdown class="full-width"
                       [(ngModel)]="locale"
                       [jbList]="localesList" (ngModelChange)="updateLocale($event)"
                       jbLabel="locale$ (translate service)"
                       jbSelect="code"
                       jbRender="name">
          </jb-dropdown>
        </div>
      </div>

      <!--Custom Error-->
      <div class="row marT15">
        <jb-checkbox class="col-3 marT30" jbLabel="Has Custom Error" [(ngModel)]="compConf.hasErrorText" (ngModelChange)="upComp()"></jb-checkbox>
        <jb-input class="col-5" jbLabel="jbErrorText" [(ngModel)]="compConf.jbErrorText" [jbDisabled]="!compConf.hasErrorText" (ngModelChange)="upComp()"></jb-input>
        <jb-dropdown class="col-4" jbLabel="jbErrorPos" [(ngModel)]="compConf.errorPos"
                     [jbList]="compConf.errorPosOpts" jbRender="text" jbSelect="id"
                     (ngModelChange)="relink(); upComp()">
        </jb-dropdown>
      </div>

      <!--Classes-->
      <div class="row marT15">
        <div class="col-8 padT5">
          <jb-label jbText="CSS Classes"></jb-label>
          <jb-checkbox class="marL20" [(ngModel)]="compConf.hasFlat"       (ngModelChange)="upComp()" jbLabel="flat"></jb-checkbox>
          <jb-checkbox class="marL20" [(ngModel)]="compConf.hasModalRight" (ngModelChange)="upComp()" jbLabel="modal-right" jbTooltip="It makes the modal open aligned to the right instead"></jb-checkbox>
          <jb-checkbox class="marL20" [(ngModel)]="compConf.hasNoMinWidth" (ngModelChange)="upComp()" jbLabel="no-min-width" jbTooltip="It removes min-width of the field"></jb-checkbox>
        </div>
      </div>

    </div>

  </div>
</div>

<hr>




<h5 class="mt-4">Examples:</h5>
<div class="col-12 examples-table">

  <div class="row">
    <div class="col-5">
      <jb-date-picker jbLabel="My Date" [(ngModel)]="myDate3">
      </jb-date-picker>
    </div>
    <div class="col-7"> <pre>{{instance}}</pre> </div>
  </div>

  <div class="row">
    <div class="col-5">
      <jb-date-picker [(ngModel)]="myDate3"
                      jbLabel="view.common.field_name3"
                      [jbRequired]="true"
                      jbMinDate="2020-01-14"
                      jbMaxDate="2020-02-09">
      </jb-date-picker>
    </div>
    <div class="col-7"> <pre>{{instance2}}</pre> </div>
  </div>

</div>



<!--CSS Styling-->
<div class="row marT40">
  <div class="col-12">
    <hr>
    <h4>CSS Styling</h4>
    <p>The encapsulated styles of the component use a default color set. However, we may want to apply different colors externally (depending on the theme)
      <br/>
      To provide a color restyling based on a SCSS theme you can apply set following SASS variables:
    </p>
    <pre>{{ cssReset }}</pre>
  </div>
</div>

